/**
 * @file serviceWorker.js
 * @description PWA service worker setup with Workbox and push notifications
 */

import { Workbox } from 'workbox-window';

let wb;

export function initializeServiceWorker() {
  if ('serviceWorker' in navigator) {
    wb = new Workbox('/sw.js');

    wb.addEventListener('installed', (event) => {
      console.log('Service Worker installed:', event);
    });

    wb.addEventListener('controlling', (event) => {
      console.log('Service Worker controlling:', event);
      window.location.reload();
    });

    wb.addEventListener('waiting', (event) => {
      console.log('Service Worker waiting:', event);
      // Show update available notification
      showUpdateAvailableNotification();
    });

    wb.register().then((registration) => {
      console.log('Service Worker registered:', registration);
      return registration;
    }).catch((error) => {
      console.error('Service Worker registration failed:', error);
    });
  }
}

export function skipWaiting() {
  if (wb) {
    wb.addEventListener('controlling', () => {
      window.location.reload();
    });
    wb.messageSkipWaiting();
  }
}

function showUpdateAvailableNotification() {
  // You can implement a custom notification component here
  if (window.confirm('A new version is available. Update now?')) {
    skipWaiting();
  }
}

// Background sync setup
export function setupBackgroundSync() {
  if ('serviceWorker' in navigator && 'sync' in window.ServiceWorkerRegistration.prototype) {
    // Background sync is handled in the service worker
    // This function can be used to register sync events from the main thread
    return navigator.serviceWorker.ready.then(registration => {
      return registration.sync.register('background-sync');
    });
  }
  return Promise.resolve(null);
}

// Push notification utilities
export async function requestNotificationPermission() {
  if (!('Notification' in window)) {
    console.log('This browser does not support notifications');
    return false;
  }

  if (Notification.permission === 'granted') {
    return true;
  }

  if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }

  return false;
}

export function showNotification(title, options = {}) {
  if ('serviceWorker' in navigator && Notification.permission === 'granted') {
    navigator.serviceWorker.ready.then((registration) => {
      registration.showNotification(title, {
        icon: '/logo192.png',
        badge: '/logo192.png',
        vibrate: [200, 100, 200],
        tag: 'memorize-life-notification',
        ...options
      });
    });
  }
}

export function subscribeToNotifications(vapidKey) {
  return navigator.serviceWorker.ready.then((registration) => {
    return registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: vapidKey
    });
  });
}
